<template>
    <div class="requestPassword-container">
        <div class="requestPassword-form">



            <v-form ref="form" @submit.prevent="save" >
                <v-row justify="center" >
                    <v-col class="text-center" >
                        <div class="font-weight-bold body-2">
                            Olvidé mi contraseña
                        </div>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-col class="py-2" cols="12" sm="9">
                        <div class="requestPassword-message">
                            Ingresa el correo electrónico asociado a tu
                            cuenta y te enviaremos instrucciones para
                            ayudarte a restablecer tu contraseña
                        </div>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-col class="py-2" cols="12" sm="9">
                        <textFieldForm 
                            @valueChange="(v) => {form.email = v.trim(); serverErrors = {} }" 
                            :valueInput="form.email" 
                            :rule="rules.email" 
                            label="Correo"
                            :errorMessages="serverErrors['email']"
                            
                        ></textFieldForm>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-col cols="12" sm="9"  class="text-center">
                        <!-- <v-row justify="end" class="px-3 py-3"> -->
                            <primary-button :props="saveBtnData" class=""></primary-button>  

                            <p v-if="showErrorMessage" class="caption red--text pt-3 pb-0 mb-0">Verifique el correo o intente más tarde</p>
                        <!-- </v-row> -->
                    </v-col>
                </v-row>

                 <v-row justify="center">
                    <v-col class="py-2" cols="12" sm="9">
                        <div class="requestPassword-return-btn clic" @click="ToLogin()">
                            Regresar al inicio de sesión
                        </div>
                    </v-col>
                </v-row>

            </v-form>
            

        </div>
    </div>
</template>

<script>
import Utils from '../../helpers/Utils';
export default {
    components: {
    },
	data(){
		return {
            showErrorMessage:false,
            loading: false,
            serverErrors: {},
            form: {
                email: '',
             
            },
            
            saveBtnData: {
                text: "Solicitar nueva contraseña",
                block: true,
                icon: "",	
                click: this.save,
                loading: false,
            },

            rules: {
				required: [
					v => {
                        if(v == null || v == undefined)
                            return "Campo requerido";
                        try {
                            if(v.trim() == "")
                                return "Campo requerido";
                        } catch (error) {
                            console.log(error);
                        }
                        return true;
                    }
				],
                email: [
                    //v => !!v || 'El campo es requerido'
                    v => {
                        if(!v)
                        return 'El campo es requerido';
                        if(v.length > 0) {
                            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            return pattern.test(v) || 'Correo no válido';
                        }
                        try {
                            if(v.trim() == "")
                                return "Campo requerido";
                        } catch (error) {
                            console.log(error);
                        }
                        return true
                    }
                ],
				
				
            },
            
		}
    },
    mounted(){
        // window.addEventListener('resize', this.onResize, { passive: true });
        // this.onResize();
    },
	methods: {
        ToLogin(){
            this.$router.push({name: 'Login'});
        },
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
            }
        },
		validate () {
            console.log(this.serverErrors)
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate()
		},
        save(){
            this.showErrorMessage = false;
            this.saveBtnData.loading = true;
            console.log(this.form);
            
            if(this.validate()){
                
                let form = JSON.parse(JSON.stringify(this.form))
                
                this.$api.auth.resetPasswordRequest(form)
                    .then(() => {
                        //console.log(response)

                        // this.$store.dispatch('snackbarSuccess', `Se ha creado correctamente`);
                        this.saveBtnData.loading = false;
                        this.$router.push({name: 'RequestPasswordSend'});
                    })
                    .catch(() => {
                        //console.log(error.response)
                       
                        this.externalRequest();

                       
                    })
                    .finally(() => {
                       
                    })
                ;
            }else{
                this.saveBtnData.loading = false;
                this.$store.state.loading = false;
                // this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },


        externalRequest(){
            console.log("entra external");
            this.saveBtnData.loading = true;
            
            if(this.validate()){
                
                let form = JSON.parse(JSON.stringify(this.form))
                
                this.$api.auth.externalResetPasswordRequest(form)
                    .then(() => {
                        //console.log(response)

                        // this.$store.dispatch('snackbarSuccess', `Se ha creado correctamente`);
                        this.$router.push({name: 'RequestPasswordSend'});
                    })
                    .catch(() => {
                        this.showErrorMessage = true;

                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                    })
                ;
            }else{
                this.saveBtnData.loading = false;
                this.$store.state.loading = false;
                // this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        }
    },
}
</script>

<style lang="scss">
    .requestPassword{

        &-container{
            z-index: 1000;
            display: flex;
            flex-direction: column;
            justify-items: center;
            justify-content: center;
            align-items: center;
            
        }

        &-message{
            line-height: 1.2rem;
            // background-color: red;
            border-left: var(--v-primary-base) 8px solid;
            padding: 0 5px;
        }

        &-form{
            display: flex;
            flex-direction: column;
            flex-direction: column;
            justify-items: center;
            justify-content: center;
            align-items: center;

            background-color: white;
            min-height: 280px;
            width: 50%;
            padding: 2rem 1rem;

            @media (max-width: #{map-get($grid-breakpoints, 'md')}) {
               width: 80%;
                
            }

            @media (max-width: #{map-get($grid-breakpoints, 'sm')}) {
               width: 95%;
                
            }

        }

        &-return-btn{
            font-size: .7rem;
            text-align: center;
            margin-top: 2rem;
        }
    }
</style>